module.exports = __webpack_public_path__ + "img/Weapon_264.2cc4b4cc.png";